export default __webpack_public_path__ + "static/media/ss_gyms_wordmark.c6803287.png";